module.exports = "<input type=\"checkbox\" checked=\"checked\" name=\"db-item\">\n<dashboard-checkbox-label></dashboard-checkbox-label>"